import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { ChatToolboxModal } from '.'
import { ToolboxWapp } from './types'
import {
  DESCRIPTIVE_EXAM_CONFIG,
  HOMEWORK_CONFIG,
  MULTIPLE_CHOICE_EXAM_CONFIG,
  NEVISEH_CONFIG,
  POLL_CONFIG,
  POST_CONFIG,
} from '$common/wapp-bar-theme'
import {
  openDescriptiveExamCreator,
  openHomeWorkCreator,
  openMultipleChoiceExamCreator,
  openNeviseCreator,
  openPollCreator,
  openPostCreator,
} from '$logic/wapps/business'

const COMPONENT_ID = 'toolBoxModal'

const showToolBoxModal = (props: Parameters<typeof ChatToolboxModal>[0]) =>
  addModal({ id: COMPONENT_ID, props })

const wapps: ToolboxWapp[] = [
  {
    ...MULTIPLE_CHOICE_EXAM_CONFIG,
    onClick: openMultipleChoiceExamCreator,
  },
  // {
  //   ...DESCRIPTIVE_EXAM_CONFIG,
  //   onClick: openDescriptiveExamCreator,
  // },
  {
    ...HOMEWORK_CONFIG,
    onClick: openHomeWorkCreator,
  },
  {
    ...POST_CONFIG,
    onClick: openPostCreator,
  },
  {
    ...POLL_CONFIG,
    onClick: openPollCreator,
  },
]

export const showChatToolBoxModal = (
  props: Parameters<typeof ChatToolboxModal>[0],
) => {
  showToolBoxModal({ ...props, wapps })
}

export default {
  [COMPONENT_ID]: {
    Component: ChatToolboxModal,
  },
}
